import { INPUT_TYPE } from '@components/dragableTableFrom/formItems';
import { insightModals } from '@model';
import { FORM_KEYS } from './form.keys';

export const INPUT_MAP = {
  [FORM_KEYS.TITLE.key]: {
    inputType: INPUT_TYPE.SIMPLE_INPUT,
    maxLength: insightModals.OPERATING_MODEL_TITLE_LIMIT,
    placeholder: FORM_KEYS.TITLE.placeholder,
  },
  [FORM_KEYS.DES.key]: {
    inputType: INPUT_TYPE.TEXT_ARRAY,
    maxLength: insightModals.OPERATING_MODEL_CONTENT_LIMIT,
    placeholder: FORM_KEYS.DES.placeholder,
  },
  [FORM_KEYS.DRAG.key]: {
    inputType: INPUT_TYPE.DRAG,
  },
};
